
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "commitHash": "334454ed1f3717affb11a943e271fe2a6330a0c5",
    "version": "9.0.1"
};
/* tslint:enable */
